import React, { Fragment, useEffect } from "react";
import { Route, Routes, useMatch } from "react-router-dom";
import { PalletManagement } from "./pallet-management/pallet-management";
import { PalletShipping } from "./pallet-shipping/pallet-shipping";
import { PalletShipped } from "./pallet-shipped/pallet-shipped";
import { WarehouseSelector } from "./warehouse-selector/warehouse-selector";
import { context } from "../../../context/context";
import { PreparationSectionType } from "../../navigation/preparation-route-props";

export interface IPalletRouterProps {
    setRouteExpanded: (route: PreparationSectionType) => void;
}

export const PalletRouter = (props: IPalletRouterProps) => {
    useEffect(() => {
        props.setRouteExpanded("pallet");
    }, []);

    const pathMath = useMatch("pallet/:page/:warehouse");

    return <Fragment>
        {context.currentUser.isSuperAdministrator && <WarehouseSelector section={"pallet"} selectedWarehouse={pathMath?.params.warehouse} />}
        <Routes>
            <Route path={`pallet-management/:warehouse?`} element={<PalletManagement/>} />
            <Route path={`pallet-shipping/:warehouse?`} element={<PalletShipping />} />
            <Route path={`shipped-pallets/:warehouse?`} element={<PalletShipped />} />
        </Routes>
    </Fragment>;
};
